import React from 'react';
import { ReactComponent } from 'Common/components/Icons/rule.svg';

const Rule = () => <ReactComponent className="MuiSvgIcon-root" />;

export default Rule;
